// dependencies
import { useQuery } from "@tanstack/react-query";

// queries
import { rbacEmployeePermissionsQuery, rbacPermissionsQuery } from "../../queries";
// api services
import { getRbacCompanySettingDependentPermission, getRbacObjectPermissions } from "../../services/defs/rbac";

export const useRbacPrimaryRolePermissions = (objectType: string, targetCompanyId?: string) => {
	return useQuery(rbacPermissionsQuery(objectType, targetCompanyId));
};

export const useRbacObjectPermissions = (objectType: string, objectId: string) => {
	return useQuery({
		queryKey: ["rbac-permissions", objectType, objectId],
		queryFn: () => getRbacObjectPermissions(objectType, objectId),
		meta: {
			errorMessage: "There was an error getting permissions.",
		},
		enabled: !!objectId,
	});
};

export const useRbacEmployeePermissions = (employeeId: string, objectType?: string, disabled = false) => {
	return useQuery<string[]>(rbacEmployeePermissionsQuery(employeeId, objectType, disabled));
};

export const useRbacCompanySettingDependentPermission = (
	companySetting: string,
	objectType: string,
	permissionName: string,
	disabled = false,
	featureFlagName?: string,
	requiredDomainRole?: string
) => {
	return useQuery<boolean>({
		queryKey: ["rbac-permissions", companySetting, objectType, permissionName, featureFlagName, requiredDomainRole],
		queryFn: async () => {
			const results = await getRbacCompanySettingDependentPermission(
				companySetting,
				objectType,
				permissionName,
				featureFlagName,
				requiredDomainRole
			);
			return results;
		},
		staleTime: 1000 * 60 * 2,
		meta: {
			errorMessage: "There was an error getting permissions.",
		},
		enabled: !disabled,
	});
};
